module.exports = __webpack_public_path__ + "assets/img/footer_room.b7a89006.svg";